import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err: any) {
      setError(err.message || 'Bejelentkezési hiba.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg">
      <div className="auth-card">
        <div className="auth-head">
          <div className="auth-logo">
            <svg width="32" height="32" viewBox="0 0 100 100">
              <path d="M16 88 L16 40 L50 64" fill="none" stroke="#14233F" strokeWidth="17" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M50 64 L84 16 L84 64" fill="none" stroke="#F47B20" strokeWidth="17" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Modulum</span>
          </div>
          <p className="auth-sub">Bejelentkezés a CRM rendszerbe</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="form-label">E-mail cím</label>
            <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="pelda@ceg.hu" autoComplete="email" />
          </div>
          <div className="auth-field">
            <label className="form-label">Jelszó</label>
            <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="Jelszó" autoComplete="current-password" />
          </div>

          {error && <div className="auth-error">{error}</div>}

          <button type="submit" disabled={loading} className="btn btn-primary" style={{ width: '100%', padding: '12px', fontSize: '15px', opacity: loading ? .6 : 1 }}>
            {loading ? 'Bejelentkezés...' : 'Bejelentkezés'}
          </button>
        </form>

        <div className="auth-footer">
          Még nincs fiókod? <Link to="/regisztracio">Regisztráció</Link>
        </div>
      </div>
    </div>
  );
}
